import AlertContext from '../../context/alert/AlertContext'
import  { useContext } from 'react';


const Alert = () => {
    const {alert} = useContext(AlertContext)

    return (
    alert !== null && (
        <p className="flex items-start mb-4 space-x-2">
            {alert.type === "error" && (
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 3V3.28988C16.8915 4.15043 19 6.82898 19 10V17H20V19H4V17H5V10C5 6.82898 7.10851 4.15043 10 3.28988V3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3ZM7 17H17V10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10V17ZM14 21V20H10V21C10 22.1046 10.8954 23 12 23C13.1046 23 14 22.1046 14 21Z" fill="currentColor" /></svg>
            )}
            <p className="flex-1 text-base font-semibold leading-7 text-white">
            <strong>{alert.msg} </strong>
            </p>
        </p>
    )
  )
}

export default Alert